module.exports = __webpack_public_path__ + "static/media/hang-out-table.0a75944a.svg";